import { DrawerObject } from '../../../../components/drawer/drawer.types';
import { FormBuilderComponent } from '../../../../components/form-builder/form-builder.component';
import { DynamicForm } from '../../../../components/form-builder/form-builder.types';
import { ContactRepository } from '../../../../store/contact-state/contact-state.repository';

interface getContactAddDrawerObjectProps {
  store: ContactRepository;
  formObject?: DynamicForm;
  toggleVisibility?: () => void;
  action?: () => void;
}

export const getContactAddDrawerObject = ({ store, formObject, toggleVisibility, action }: getContactAddDrawerObjectProps): DrawerObject => {
  return {
    title: 'settings.contact.add.title',
    description: 'settings.contact.add.description',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject: formObject,
      },
    },
    actions: [
      {
        label: 'settings.contact.add.add',
        onClick: () => action?.(),
      },
      {
        label: 'settings.contact.add.cancel',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
